import { Injectable, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: number;
  type: ToastType;
  title: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toasts: WritableSignal<Toast[]> = signal([]);

  private counter: number = 0;

  constructor(private translate: TranslateService) {}

  error(msg: string|null, title: string = 'error.error'): void {
    this.show('error', msg ?? 'error.server-communication-error', title);
  }

  success(msg: string, title: string = 'success.success'): void {
    this.show('success', msg, title);
  }

  remove(id: number): void {
    this.toasts.update((list: Toast[]): Toast[] => list.filter((t: Toast): boolean => t.id !== id));
  }

  private show(type: ToastType, msgKey: string, titleKey: string, timeout: number = 5000): void {
    this.translate.get([msgKey, titleKey]).subscribe((res: any): void => {
      const id: number = ++this.counter;
      this.toasts.update((list: Toast[]): Toast[] => [{ id, type, title: res[titleKey], message: res[msgKey] }, ...list]);
      if (timeout > 0) {
        setTimeout((): void => this.remove(id), timeout);
      }
    });
  }

}
